import { useLogging } from "../../../Shared/hooks/useLogging/useLogging";
import { useRecipes } from "../../OrderFlowProvider/OrderFlow.requests";
import { useOrderFlow } from "../../OrderFlowProvider/OrderFlowContext";
import { getMealsWithSelectionSource, getRecipes } from "./recipeSelectionUtils";
/**
 * Returns the functions needed for normal and automatic recipe selection
 */
export const useRecipeSelection = () => {
    const { getSelectedRecipes } = useRecipes();
    const { dispatch } = useOrderFlow();
    const { datadogLog } = useLogging();
    return {
        getRecipes: getRecipes(dispatch, getSelectedRecipes, datadogLog),
        getMealsWithSelectionSource,
    };
};
